<template #contentTemplate="{}">
  <div>
      <div v-if="open" class="modal--backdrop" @click="open = false"></div>
      <div v-if="open" class="card combobox">
        <BasicTextInput 
          :customStyles="{marginBottom: '10px'}"
          label="Order" placeholder="search..." :focus="true" @change="debounce(customInputChanged, 500)" v-model="customInput"/>
        <DxDataGrid
          :data-source="dataSource"
          :height="200"
          width="100%"
          :row-alternation-enabled="true"
          :selected-row-keys="[currentValue]"
          :hover-state-enabled="true"
          :focused-row-enabled="true"
          :onRowClick="onSelectionChanged"
          :focused-row-key="currentValue"
          :show-borders="true"
          :remoteOperations="true"
          key-expr="WorksheetName"
        >

          <DxFilterRow  :showOperationChooser="false" :visible="true"/>
          <!-- <DxFilterRow :visible="true" /> -->
          <DxSearchPanel :text="searchInput" :visible="false" :width="460"/>
          <DxColumn :width="100" data-field="OrderNumber" cell-template="grid-cell"/>
          <DxColumn :width="355" data-field="WorksheetName" caption="Worksheet Name" cell-template="grid-cell"/>

          <DxColumn :width="0" :visible="true" :filterValue="1" data-field="OrderStatusId" caption="Order Status" cell-template="grid-cell"/>
          <DxColumn :width="0" :visible="true" :filterValue="currentCustomerId" data-field="CustomerId" caption="Customer Id" cell-template="grid-cell"/>
          <template  #grid-cell="{ data }">
            <div class="cell" style="fontSize:10px">{{ data.text }}</div>
          </template>
          <!-- <template  #grid-cell-order-status="{ data }">
            <div class="cell" style="fontSize:10px">{{ getOrderStatus(data.text) }}</div>
          </template> -->
          <DxScrolling mode="virtual"/>
          <DxPaging
            :enabled="true"
            :page-size="50"
          />
        </DxDataGrid>
      </div>
    </div>
</template>
<script>

import {
  DxDataGrid,
  DxFilterRow,
  DxPaging,
  DxSelection,
  DxScrolling,
  DxColumn,
  DxSearchPanel
} from 'devextreme-vue/data-grid';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import BasicTextInput from '../components/inputComponents/BasicTextInput.vue';
import { OrderService } from '@/services'
// import { getDataSource  } from '../modules/helpers'; 

// let dataSource = getDataSource('Orders')
const dropDownBoxRefName = 'orderSearchDropdown';

export default {
  components: {
    DxSearchPanel,
    DxDataGrid,
    DxFilterRow,
    DxPaging,
    DxSelection,
    DxScrolling,
    DxColumn,
    DxDropDownBox,
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    currentCustomerId: {
      type: Number,
      default: null,
    },
    onValueChanged: {
      type: Function,
      default: () =>  {}
    },
    // dataSource: {
    //   type: Object,
    //   default: () => {}
    // }
  },
  data() {
    return {
      open: false,
      dataSource: [],
      currentValue: null,
      dropDownOptions: { width: 500 },
      dropDownBoxRefName,
      customInput: '',
      searchInput: '',
      timerId: null,
    };
  },
  
  methods: {
    debounce(func, wait) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(func, wait)
    },
    // getOrderStatus(statusId){
    //   console.log(statusId)
    //   return getKeyByValue(orderStatusEnum, Number(statusId))
    // },
    onSelectionChanged(selectionChangedArgs) {
      if(!selectionChangedArgs) return;
      console.log('hi', selectionChangedArgs.data)
      this.$emit('orderSelected', selectionChangedArgs.data)
      this.toggle()
    },

    toggle(){
        this.open = !this.open;
    },
    customInputChanged(){
      this.searchInput = this.customInput
      this.currentValue = this.customInput
      this.onValueChanged(this.currentValue)
    },
    getOrders(){
      this.dataSource = OrderService.getDataSource();
    }
  },
  created(){
    this.currentValue = this.value;
    this.getOrders();
  },
};
</script>
<style lang="scss" scoped>
  .modal--backdrop {
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    min-width: 100%;
    z-index: 100;
    opacity: 0;
    
  }
  .combobox {
    position: absolute;
    z-index: 100;
    width: 500px;
    height: 350px;
    padding: 20px;
  }
  .header {
    color: $primary;
    font-size: 12px;
  }
  .cell {
    color: $ss_grey1;
    font-size: 10px;
  }
</style>